import React, { Component } from 'react';
import Dropdown from '../common/Dropdown';
import { DropdownButton, MenuItem, Media } from 'react-bootstrap';
import { map } from 'lodash';
import moment from 'moment';
import MessageEmptyState from '../EmptyState/MessageEmptyState';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import { defaultImageOnError } from '../../helpers'; 

export default class MessagesDropdownView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMessagesLoaded: false
    };
  }
  componentWillMount() {
    if (!this.props.commonReducer.isMessagesLoaded) {
      if(localStorage.garage_id != "undefined"){
        this.props.actions.getAllUnreadMessages(localStorage.garage_id);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer && nextProps.commonReducer.isMessagesLoaded && !this.state.isMessagesLoaded) {
      this.setState({
        'isMessagesLoaded': true
      });
    }
  }
  render() {
    const {commonReducer} = this.props;
    const messagesView = map(commonReducer.unreadMessages, (message, key) => {
      const nameFirstLetter = (message.user && message.user.name) ? message.user.name.toUpperCase() : '';
      let colorChange ='';
      if(nameFirstLetter.charCodeAt(0)> 64 && nameFirstLetter.charCodeAt(0)<= 69){
        colorChange ={'backgroundColor':'#EAABAA'};
      } else if(nameFirstLetter.charCodeAt(0)> 69 && nameFirstLetter.charCodeAt(0)<= 74){
        colorChange ={'backgroundColor':'#AED5D1'};
      } else if(nameFirstLetter.charCodeAt(0)> 74 && nameFirstLetter.charCodeAt(0)<= 79){
        colorChange ={'backgroundColor':'#D0E2B2'};
      } else if(nameFirstLetter.charCodeAt(0)> 79 && nameFirstLetter.charCodeAt(0)<= 84){
        colorChange ={'backgroundColor':'#F7E196'};
      } else if(nameFirstLetter.charCodeAt(0)> 84 && nameFirstLetter.charCodeAt(0)<= 90){
        colorChange ={'backgroundColor':'#DBDBD9'};
      } else {
        colorChange ={'backgroundColor':'#C7C7E5'};
      }
      return (
        <MenuItem eventKey={message.key} key={key} onClick={(e) => {e.preventDefault(); this.props.actions.toggleMessageTab(true); this.props.router.push(`${appBasePath}/job/${message.userbookingrequest.id}?current_tab=messages`); if (!(message && message.lastMessage && message.lastMessage.seen)) {this.props.actions.markMessagesAsReadFromDropDown(message.lastMessage.jobChatRoomId || message.lastMessage.jobChatroomId);}}}>
          <Media>
            <Media.Left>
              <div className="notification-img">
                {(message.user && message.user.profilePhoto && message.user.profilePhoto.trim().length > 0) ?
                  <img src={message.user.profilePhoto} alt="Image" 
                  onError={(e)=>{e.target.onerror = null; e.target.src= defaultImageOnError()}}
                />
                  : <p className="message-no-image-color" style={colorChange}>{nameFirstLetter[0]}</p>
                }
              </div>
            </Media.Left>
            <Media.Body>
              <Media.Heading>{message.user.name}</Media.Heading>
              <p>{message.lastMessage.msg} </p>
            </Media.Body>
          </Media>

        </MenuItem>
      )
    });
    return (
      <li className={this.state.messageSelected?"notification-menu desktop-view active":"notification-menu desktop-view"}>
        <div className="text-dropdown notify business msg" >
          <DropdownButton bsSize="large" id="dropdown-size-large" noCaret onToggle={() => { this.setState({ messageSelected: !this.state.messageSelected }) }} title={
            <div className="d-inline-block" onClick={this.props.msgClick}>
              <i className="mdi mdi-message-processing" aria-hidden="true" />
              {commonReducer.unreadMessages.length > 0 && <span className="no-notify"/>}
            </div>} >
            <MenuItem eventKey="Messages">
              Messages
              <a className="view_all" onClick={() => { this.props.router.push(`${appBasePath}/inbox`); }}>View All</a>
            </MenuItem>
              {this.state.isMessagesLoaded ?
                commonReducer.unableToFetchUnreadMessages
                  ? <div><h3 className="unable-message-notes">Unable to fetch messages <a style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault; this.props.actions.getAllUnreadMessages(localStorage.garage_id); }}>Try Again</a></h3></div>
                  : (commonReducer.unreadMessages && commonReducer.unreadMessages.length > 0) ? messagesView : <MessageEmptyState />
                : <div><h3 className="msg-empty-state">Loading...</h3></div>}
          </DropdownButton>
        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/MessagesDropdownView.jsx